import React, { createContext, useContext, useState } from 'react';

const HeaderSlotContext = createContext(null);

// Owija całą aplikację (w Layout.js) - trzyma referencję do DOM-owego slotu
// w pasku nagłówka, do którego inne strony (np. Tables.js) mogą portalować
// własną zawartość (np. pigułki "3 zajęte / 38 wolne").
export function HeaderSlotProvider({ children }) {
  const [slotEl, setSlotEl] = useState(null);
  return (
    <HeaderSlotContext.Provider value={{ slotEl, setSlotEl }}>
      {children}
    </HeaderSlotContext.Provider>
  );
}

// Używane przez Layout.js - zwraca funkcję ref do podpięcia pod div-slot
export function useHeaderSlotRef() {
  const ctx = useContext(HeaderSlotContext);
  return ctx?.setSlotEl;
}

// Używane przez strony (np. Tables.js) - zwraca aktualny element slotu (albo null,
// dopóki Layout go nie zamontuje) do użycia z ReactDOM.createPortal
export function useHeaderSlot() {
  const ctx = useContext(HeaderSlotContext);
  return ctx?.slotEl || null;
}
